/**
 * @Author: DJ
 * @Date:   2021-09-06 13:43:26
 * @Last Modified by:   DJ
 * @Last Modified time: 2022-06-10 16:40:09
 */
import React from 'react';
import { XPagination } from '@/components/xqxc_ui';
import { message, Table } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { isPlat } from '@/assets/js/authType';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import styles from './TableList.module.scss';
import { MainTableFields as tf } from '../../types';
import ButtonPerssion from '@/routes/ButtonPerssion';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '站点信息',
            dataIndex: 'targetName',
            key: 'targetName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '对账周期',
            dataIndex: 'recTime',
            key: 'recTime',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            // render: tooltip
            render: (text, record) => {
                return <p>
                    <span>{record && record.startTime ? moment(record.startTime).format('YYYY-MM-DD') : ''}</span>~
                    <span>{record && record.endTime ? moment(record.endTime).format('YYYY-MM-DD') : ''}</span></p>
            }
        },
        {
            title: '结算模式',
            dataIndex: 'settleModeValue',
            key: 'settleModeValue',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '收入金额',
            dataIndex: 'reconAmount',
            key: 'reconAmount',
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '支出金额',
            dataIndex: 'expendAmount',
            key: 'expendAmount',
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '应结金额',
            dataIndex: 'payableAmount',
            key: 'payableAmount',
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },

        {
            title: '生成时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '站点是否呈现',
            dataIndex: 'isAppear',
            key: 'isAppear',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => <div>{record && record.isAppear == 1 && '是'}{record && record.isAppear == 0 && '否'}</div>
        },
        {
            title: '状态',
            dataIndex: 'verifyStatusValue',
            key: 'verifyStatusValue',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            width: cellWidth.normal,
            render: (text, record) => record && this._renderActionCell(record.id, record)
        }
    ]);

    _renderActionCell = (key, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <ButtonPerssion code='finance/microtransportstatements/detail'>
                    <div className={styles.item} onClick={() => tableAction({ id: key, settleMode: record.settleMode }, 'detail')}>详情</div>
                </ButtonPerssion>
                <ButtonPerssion code='finance/microtransportstatements/visible'>
                    <div className={styles.item} onClick={() => tableAction({ id: key, isAppear: record.isAppear == 0 ? 1 : 0 }, 'isAppear')}>{record.isAppear == 0 ? '呈现' : '不呈现'}</div>
                </ButtonPerssion>
                {isPlat() ?
                    record.verifyStatus == 'CONFIRM_SUCCESS' && <ButtonPerssion code='finance/microtransportstatements/sgdk'><div className={styles.item} onClick={() => tableAction(key, 'pay')}>手工打款</div></ButtonPerssion>
                    :
                    record.verifyStatus == 'TO_CONFIRM' && <ButtonPerssion code='finance/microtransportstatements/qrdzd'><div className={styles.item} onClick={() => tableAction(key, 'sureAccount')}>确认对账单</div></ButtonPerssion>
                }

                {/* <div className={styles.item} onClick={() => {
                    if(record.url){
                        tableAction(record.url, 'export');
                    }else{
                        message.warning('暂无数据');
                    }
                }}>导出对账单</div> */}
                {/* <div className={styles.item} onClick={() => tableAction(key, 'delete')}>删除</div> */}
            </div>
        );
    }

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey='id'
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    actionHandle: PropTypes.func,
};

export default TableList;